import * as React from 'react';

const CheckIcon = props => (
  <svg
    viewBox="0 0 154 154"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.256 55.894a4.5 4.5 0 0 1-.15 6.362l-44.025 42a4.499 4.499 0 0 1-6.215-.003l-21.975-21a4.5 4.5 0 1 1 6.218-6.506l18.869 18.031 40.916-39.034a4.5 4.5 0 0 1 6.362.15Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77 9.5C39.72 9.5 9.5 39.72 9.5 77c0 37.279 30.22 67.5 67.5 67.5 37.279 0 67.5-30.221 67.5-67.5 0-37.28-30.221-67.5-67.5-67.5ZM.5 77C.5 34.75 34.75.5 77 .5s76.5 34.25 76.5 76.5-34.25 76.5-76.5 76.5S.5 119.25.5 77Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckIcon;
